import { createAction, props } from '@ngrx/store';

// check consolidato: se esiste e se è chiuso
export const checkConsolidato = createAction(
  `[Lazy/CheckBilanci] Check Consolidato `,
  props<{
    anno: number | undefined;
  }>()
);

export const checkConsolidatoSuccess = createAction(
  `[Lazy/CheckBilanci] Check Consolidato Success`,
  props<{
    exists: boolean;
    closed: boolean;
    anno: number | null;
    enteId: number | null;
  }>()
);

export const checkConsolidatoFailure = createAction(
  `[Lazy/CheckBilanci] Check Consolidato Failure`,
  props<{
    error: string;
  }>()
);

// check esercizio chiuso
export const checkEsercizioChiuso = createAction(
  `[Lazy/CheckEsercizioChiuso] Check Esercizio Chiuso`
);

export const checkEsercizioChiusoSuccess = createAction(
  `[Lazy/CheckEsercizioChiuso] Check Esercizio Chiuso Success`,
  props<{ closed: boolean; anno: number | null; enteId: number | null }>()
);

export const checkEsercizioChiusoFailure = createAction(
  `[Lazy/CheckEsercizioChiuso] Check Esercizio Chiuso Failure`,
  props<{
    error: string;
  }>()
);

// check dati per riepilogo modificati
export const checkDatiRiepilogoModificati = createAction(
  `[Lazy/CheckDatiRiepilogoModificati] Check Dati Riepilogo Modificati`
);

export const checkDatiRiepilogoModificatiSuccess = createAction(
  `[Lazy/CheckDatiRiepilogoModificati] Check Dati Riepilogo Modificati Success`,
  props<{ modificati: boolean }>()
);

export const checkDatiRiepilogoModificatiFailure = createAction(
  `[Lazy/CheckDatiRiepilogoModificati] Check Dati Riepilogo Modificati Failure`,
  props<{
    error: string;
  }>()
);
